import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http: HttpClient) { }

  private apiUrl = 'https://your-backend-api-url.com'; // Replace with your API URL
  // Notification URLs
  private urlGetNotification:string = environment.CMSAPI + "Notification/GetCitizenUserNotificationviewmore";
  private urlUpdateNotification:string = environment.CMSAPI + "Notification/UpdateCitizenUserReadNotification";

  sendOtp(aadhar: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/send-otp`, { aadhar });
  }

  // Notification APIs
  public getCitizenNotifications(Body:any){
    return this.http.post(this.urlGetNotification,Body);
  }

  public updateCitizenNotifications(Body:any){
    return this.http.post(this.urlUpdateNotification,Body);
  }
}
